import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import "./index.less";
var Loading = function Loading() {
  return /*#__PURE__*/React.createElement("div", {
    className: "dumi-default-loading-skeleton"
  }, /*#__PURE__*/React.createElement(Skeleton, {
    className: "first-line",
    count: 1
  }), /*#__PURE__*/React.createElement(Skeleton, {
    count: 2
  }), /*#__PURE__*/React.createElement(Skeleton, {
    count: 1,
    width: "75%"
  }));
};
export default Loading;